const skillData = [
    {
        key: "angular",
        title: "Angular",
        value: "90",
        maxValue: "100",
        progressText: "High"
    },
    {
        key: "react",
        title: "React",
        value: "60",
        maxValue: "100",
        progressText: "Medium"
    },
    {
        key: "javaScript",
        title: "JavaScript",
        value: "80",
        maxValue: "100",
        progressText: "High"
    },
    {
        key: "java",
        title: "Java",
        value: "80",
        maxValue: "100",
        progressText: "High"
    },
    {
        key: "sqlServer",
        title: "SQL Server",
        value: "90",
        maxValue: "100",
        progressText: "High"
    },
    {
        key: "sharePoint",
        title: "SharePoint",
        value: "90",
        maxValue: "100",
        progressText: "High"
    },
    {
        key: "git",
        title: "Git",
        value: "90",
        maxValue: "100",
        progressText: "High"
    },
    {
        key: "typeScript",
        title: "TypeScript",
        value: "80",
        maxValue: "100",
        progressText: "High"
    },
    {
        key: "html",
        title: "HTML",
        value: "70",
        maxValue: "100",
        progressText: "Medium"
    },
    {
        key: "css",
        title: "CSS",
        value: "70",
        maxValue: "100",
        progressText: "Medium"
    },
    {
        key: "azure",
        title: "Azure",
        value: "50",
        maxValue: "100",
        progressText: "Medium"
    },
    {
        key: "angularJS",
        title: "Angular JS",
        value: "70",
        maxValue: "100",
        progressText: "Medium"
    },
    {
        key: "powerAutomate",
        title: "Power Automate",
        value: "70",
        maxValue: "100",
        progressText: "Medium"
    },
    {
        key: "cSharp",
        title: "C#",
        value: "50",
        maxValue: "100",
        progressText: "Medium"
    },
    {
        key: "nodeJS",
        title: "Node JS",
        value: "40",
        maxValue: "100",
        progressText: "Medium"
    }
];

export default skillData;